import { fromJS } from 'immutable';
import {
  findPropertiesByCourseware,
  selectPropertyObject,
} from '@pearsontechnology/aero-plugin-schema';

import * as coursewareTypes from 'pluginServices/constants/coursewareTypes';
import PluginService from '../PluginService';
import InteractiveService from '../InteractiveService';

import * as keyPaths from './keyPaths';

export const addChildInConfig = (newChild, schema, keyPath, oldConfig) => {
  const schemaProperty = selectPropertyObject(schema, keyPath);
  const isList = schemaProperty && schemaProperty.type === 'list';

  let newValue = newChild;
  if (isList) {
    const oldProperty = oldConfig.getIn(keyPath);
    const oldValue = oldProperty ? oldProperty.toJS() : [];
    newValue = [...oldValue, newChild];
  }

  return oldConfig.setIn(keyPath, newValue);
};

const _getCoursewareProperties = async (interactiveId) => {
  const { pluginId, version } = await InteractiveService.getInInteractive(interactiveId, keyPaths.pluginRef);
  const plugin = await PluginService.getPlugin(pluginId, version);
  const configurationSchema = JSON.parse(plugin.manifest.configurationSchema || '{}');

  return findPropertiesByCourseware(configurationSchema);
};

const _getComponents = async (interactiveId) => {
  const components = [];
  const registeredComponents = fromJS(await InteractiveService.getInInteractive(interactiveId, keyPaths.components));
  const configurationData = fromJS(await InteractiveService.getInInteractiveConfig(interactiveId));
  const coursewareProperties = await _getCoursewareProperties(interactiveId);

  coursewareProperties.forEach((descriptor) => {
    const coursewareProperty = configurationData.getIn(descriptor.path);
    if (
      typeof coursewareProperty !== 'undefined'
      && coursewareProperty !== null
      && registeredComponents
    ) {
      let coursewarePropertyJSObj = coursewareProperty.toJS();

      if (!Array.isArray(coursewarePropertyJSObj)) {
        coursewarePropertyJSObj = [coursewarePropertyJSObj];
      }

      // Ensure any components found in the schema actually exist in the interactive
      const filteredCoursewareProperty = coursewarePropertyJSObj
        .filter(({ itemId }) => registeredComponents.includes(itemId));

      components.push({
        path: descriptor.path,
        isList: descriptor.isList,
        coursewareProperty: filteredCoursewareProperty,
      });
    }
  });
  return components;
};

const _getComponentList = async (interactiveId) => {
  let componentList = [];
  const childComponents = await _getComponents(interactiveId);

  for (const childComponent of childComponents) {
    if (childComponent.isList) {
      for (const coursewareProperty of childComponent.coursewareProperty) {
        const id = coursewareProperty.itemId;
        componentList = componentList.concat({ id, type: coursewareTypes.COMPONENT });
      }
    }
  }

  return componentList;
};

export const getCoursewareList = async (coursewareProperty) => {
  let coursewareList = [];
  if (coursewareProperty) {
    const id = coursewareProperty.itemId;
    const interactiveCourseware = { id, type: coursewareTypes.INTERACTIVE };
    const componentList = await _getComponentList(id);

    coursewareList = [interactiveCourseware, ...componentList];
  }
  return coursewareList;
};

export const getAllStageElements = (stage) => {
  const elements = [];
  for (const section of stage?.sections || []) {
    for (const row of section.rows || []) {
      for (const column of row.columns || []) {
        elements.push(...(column.stageElements || []));
      }
    }
  }
  return elements;
};